import { useState, useEffect, useCallback } from 'react'

export function useNonnaProfileViewModel(repository, nonnaId) {
  const [status, setStatus] = useState('idle') // idle | loading | loaded | failed
  const [nonna, setNonna] = useState(null)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    if (!nonnaId) return
    setStatus('loading')
    try {
      const data = await repository.fetchNonnaById(nonnaId)
      setNonna(data)
      setStatus('loaded')
    } catch (err) {
      setError(err.message ?? 'This Nonna is no longer available.')
      setStatus('failed')
    }
  }, [repository, nonnaId])

  useEffect(() => {
    load()
  }, [nonnaId]) // eslint-disable-line

  return { status, nonna, error }
}
